"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _blocks = require("@bueno/blocks");

var _styledComponents = _interopRequireDefault(require("styled-components"));

const StyledAlert = _styledComponents.default.div`
  padding: 10px !important;
  margin-bottom: ${_blocks.spacing.loose};
  &.alert-error {
    background-color: ${_blocks.palette.red3};
    color: ${_blocks.palette.red7};
  }
  &.alert-success {
    background-color: ${_blocks.palette.green3};
    color: ${_blocks.palette.green7};
  }
  &.alert-warning {
    background-color: ${_blocks.palette.yellow3};
    color: ${_blocks.palette.yellow7};
  }
`;

const MsgAlert = ({
  type,
  message
}) => {
  if (!message) return null;
  return /*#__PURE__*/_react.default.createElement(StyledAlert, {
    className: `alert-${type}`
  }, /*#__PURE__*/_react.default.createElement(_blocks.Body, {
    as: "div"
  }, /*#__PURE__*/_react.default.createElement(_blocks.Markdown, null, (typeof message === 'object' ? JSON.stringify(message) : message) || '')));
};

MsgAlert.propTypes = {
  type: _propTypes.default.string.isRequired,
  message: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.object.isRequired])
};
MsgAlert.defaultProps = {
  message: ''
};
var _default = MsgAlert;
exports.default = _default;
module.exports = exports.default;